import { makeStyles } from "@mui/styles";
import clsx from "clsx";

import { Spacing } from "../../../constants";
import { PopupSheetDefinition } from "./popupSheet.definition/popupSheet.definition.types";

export const PopupSheetGrowingContent: PopupSheetDefinition["GrowingContent"] =
  ({ children, maxHeight, noPadding }) => {
    const classes = useStyles();

    return (
      <div
        className={clsx(
          classes.container,
          !noPadding && classes.paddedContainer,
        )}
        style={{ maxHeight }}
      >
        {children}
      </div>
    );
  };

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
  paddedContainer: {
    padding: `0 ${Spacing.S16}px`,
  },
});
